import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";

interface AgeConfirmDialogModalData {
  title: string | (() => string);
  description: string | (() => string);
  buttonTextAccept: string | (() => string);
  buttonTextDeny: string | (() => string);
  icon?: string | (() => string);
  notice: string | (() => string);
}

@Component({
  selector: "ya-ageConfirmDialog",
  templateUrl: "./ageConfirmDialog.component.html",
  styleUrls: ["./ageConfirmDialog.component.scss"]
})

export class AgeConfirmDialogComponent implements OnInit {
  private _langSubscriber: Subscription;

  constructor(public bottomSheetRef: MatBottomSheetRef<AgeConfirmDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: AgeConfirmDialogModalData
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("AgeConfirmDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    this._langSubscriber = this._internationalisationService.localeChanged.subscribe(() => {
      this.PushChanges();
    });
  }

  public evaluateLanguageString(s: string | (() => string) | boolean): string {
    const me = this;
    if (typeof s === "string") {
      return me._coreLanguageService.value(s);
    } else if (typeof s === "function") {
      return s();
    }
  }

  public ConfirmBtn() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  public DenyBtn() {
    const me = this;
    me.bottomSheetRef.dismiss(false);
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }
}
